import { parseAppSearch } from "./search-params"

/** Link options for a built in-app URL, since a Link `to` cannot carry the query or the hash. */
export function hrefLinkOptions(href: string) {
	const url = new URL(href, "http://app.invalid")
	return {
		to: url.pathname,
		search: parseAppSearch(url.search),
		hash: url.hash.slice(1) || undefined,
	}
}
